import { render, staticRenderFns } from "./InventarioTalhao.vue?vue&type=template&id=43f7427b&scoped=true"
import script from "./InventarioTalhao.vue?vue&type=script&lang=js"
export * from "./InventarioTalhao.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=43f7427b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f7427b",
  null
  
)

export default component.exports